export const getUserPlan = (): string => {
    const search = new URLSearchParams(window.location.search)
    return search.get("plan") || "FREEMIUM"
}

export const getUserPlanAttributes = (): { "custom:plan": string } => ({
    "custom:plan": `${getUserPlan()}`
})
